module.exports = __webpack_public_path__ + "8275090ee300dca73c63a65231ad2b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/language-switcher/flags/fr.png
// module id = 1052
// module chunks = 0